export default "ecfb47a682b7d2c0.png"